import React from 'react';

export default ({ data, lineGenerator, ...otherProps }) => (
  <path d={lineGenerator(data)} strokeWidth="2" fill="none" {...otherProps} />
);
